module.exports = __webpack_public_path__ + "img/icon12.cf4ea0c6.png";